import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { isAdmin } from './isAdmin'

// Route guard for admin-only pages. Waits for Firebase to resolve the auth
// state, then redirects non-admins to the home page so admin routes are never
// accessible (or even rendered) for regular users.
function RequireAdmin({ user, resolved, children }) {
  if (!resolved) return null
  if (!isAdmin(user)) return <Navigate to="/" replace />
  return children
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  resolved: state.auth.resolved,
})

export default connect(mapStateToProps)(RequireAdmin)
